import React from "react";
import { useController } from "react-hook-form";
import MaterialTextField, {
  TextFieldProps as MuiTextFieldProps
} from "@material-ui/core/TextField";

export type TextFieldProps = Omit<MuiTextFieldProps, "name" | "variant"> & {
  inputRef?: React.Ref<any>;
  name: string;
  variant?: MuiTextFieldProps["variant"];
};

export function TextField({ inputRef, name, label, onBlur, variant, ...rest }: TextFieldProps) {
  const { field, fieldState } = useController({ name });

  const errorText = fieldState.error?.message;
  const errorOrLabel = errorText ? `${label}: ${errorText}` : label;

  return (
    <MaterialTextField
      {...rest}
      variant={variant}
      name={field.name}
      value={field.value || ""}
      onChange={field.onChange}
      inputRef={inputRef || field.ref}
      onBlur={(e) => {
        onBlur && onBlur(e);
        field.onBlur();
      }}
      label={errorOrLabel}
      error={Boolean(errorText)}
    />
  );
}

export default TextField;
